module.exports = __webpack_public_path__ + "img/configured_alerts.b4fb577c.svg";